<template lang="html">
    <div class="pagination d-flex justify-content-end align-items-center">
        <span @click="firstPage();" class="pointer" :class="isFirstPage() ? 'disabled' : ''"> <i class="fa fa-step-backward fa-lg"></i> </span>
        <span @click="previousPage();" class="pointer ml-3" :class="isFirstPage() ? 'disabled' : ''"> <i class="fa fa-chevron-left fa-lg"></i> </span>
        <span class="ml-3 page-numbers"> {{ itemPagination.currentPage + 1 }} / {{ itemPagination.totalPages + 1 }} </span>
        <span @click="nextPage();" class="pointer ml-3" :class="isLastPage() ? 'disabled' : ''"> <i class="fa fa-chevron-right fa-lg"></i> </span>
        <span @click="lastPage();" class="pointer ml-3" :class="isLastPage() ? 'disabled' : ''"> <i class="fa fa-step-forward fa-lg"></i> </span>
    </div>
</template>

<script lang="js">

export default {
    name: 'default-pagination',
    components: {},
    props: [
        'itemPagination', 'offset'
    ],
    data () {
        return {
        }
    },
    created() {
    },
    methods: {
        firstPage() {
            if (this.offset > 0) {
                this.$emit('change', 0);
            }
        },
        previousPage() {
            if (this.offset > 0 && this.offset <= this.itemPagination.totalPages) {
                this.$emit('change', this.offset-1);
            }
        },
        nextPage() {
            if (this.offset >= 0 && this.offset < this.itemPagination.totalPages) {
                this.$emit('change', this.offset+1);
            }
        },
        lastPage() {
            if (this.offset < this.itemPagination.totalPages) {
                this.$emit('change', this.itemPagination.totalPages);
            }
        },
        isFirstPage() {
            return this.offset === 0;
        },
        isLastPage() {
            return this.offset === this.itemPagination.totalPages;
        }
    },
}
</script>

<style scoped lang="scss">
.pagination {
    .page-numbers {
        font-size: 16px;
    }
    .disabled {
        color: #9b9b9b;
    }
}
</style>



// WEBPACK FOOTER //
// DefaultPagination.vue?2f7c4ec3